import { sortCovers } from '../utils';
import { useCoverOptions } from './useCoverOptions';
import { useAppSelector } from './useSelectors';

export const useReviewAndPay = () => {
  const { data } = useCoverOptions();
  const { additionalCovers } = useAppSelector((state) => state.reviewAndPay);
  return {
    additionalCovers: sortCovers(additionalCovers, data),
  };
};
